export enum CreditCardType {
	AX = 1,
	JC = 2,
	MC = 3,
	NS = 4,
	VS = 5,
	OTHER = 6,
}
